import React from 'react'
import { useIntl } from 'react-intl'

import { MessageBox, MESSAGE_BOX_VARIANT_WARNING } from 'mailup-web-components'

const HeaderMessageBox = () => {
  const intl = useIntl()

  return (
    <MessageBox variant={MESSAGE_BOX_VARIANT_WARNING}>
      {intl.formatMessage(
        { id: 'Load.SelectEmailMessage.Info' },
        {
          linebreak: <br />,
          strong: str => <strong>{str}</strong>
        }
      )}
    </MessageBox>
  )
}

export default HeaderMessageBox
